import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AiBudgetSnapshot } from '../../services/ai-budget/ai-budget.types';

@Component({
  selector: 'app-ai-budget-card',
  templateUrl: './ai-budget-card.component.html',
  styleUrls: ['./ai-budget-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiBudgetCardComponent {
  @Input() snapshot: AiBudgetSnapshot | null = null;
  @Input() canEdit = false;
  @Output() editRequested = new EventEmitter<void>();

  get progress(): number {
    if (this.snapshot && this.snapshot.capUsd > 0) {
      return this.snapshot.usedUsd / this.snapshot.capUsd;
    }
    return 0;
  }

  onEditClick(): void {
    this.editRequested.emit();
  }
}
